import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    parentProductId: string;
    localId: string;
};

type HandlerType = Handler<Parameter>;

const DispatchRemoveClipboardCustomIncludeItem: HandlerType = props => {    
    props.dispatch({
        type: "Widgets/Clipboard/RemoveCustomIncludeItem",
        parameter: {
            parentProductId: props.parameter.parentProductId,
            localId: props.parameter.localId,
        },
    });
};

const chain = [DispatchRemoveClipboardCustomIncludeItem];

const removeClipboardCustomIncludeItem = createHandlerChainRunner(chain, "RemoveClipboardCustomIncludeItem");
export default removeClipboardCustomIncludeItem;
